import { Group, Rect, Text } from 'react-konva';
import { GENRE_NAMES, CardGenre } from '../types';

interface GameInfoProps {
  genre: number;
  level: number;
  x: number;
  y: number;
}

const LEVEL_NAMES: Record<number, string> = {
  3: '3', 4: '4', 5: '5', 6: '6', 7: '7',
  8: '8', 9: '9', 10: '10', 11: 'J', 12: 'Q', 13: 'K', 14: 'A', 15: '2',
};

export function GameInfo({ genre, level, x, y }: GameInfoProps) {
  return (
    <Group x={x} y={y}>
      <Rect
        x={-80}
        y={-25}
        width={160}
        height={50}
        fill="rgba(0,0,0,0.6)"
        cornerRadius={8}
      />
      
      <Text
        x={-70}
        y={-10}
        text={`当前: ${GENRE_NAMES[genre as CardGenre] || '无'}`}
        fontSize={16}
        fill="#fff"
        width={140}
        align="center"
      />
      
      <Text
        x={-70}
        y={10}
        text={`级数: ${LEVEL_NAMES[level] || level}`}
        fontSize={14}
        fill="#ffd700"
        width={140}
        align="center"
      />
    </Group>
  );
}